import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPowerIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 25,
	height: 24,
	viewBox: "0 0 25 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M11.5507 0.505859L6.21094 14.1914L10.856 13.9383L11.1256 23.3825L16.7556 9.90958L12.0173 10.1728L11.5507 0.505859Z",
			stroke: "#1F006C",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M7.91223 22.3921C3.59896 20.8029 0.519531 16.7236 0.519531 11.9458C0.519531 7.16802 3.66117 3.01784 8.04702 1.45898",
			stroke: "#1F006C",
			strokeMiterlimit: 10,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M14.918 1.01172C20.1229 2.05433 24.0422 6.54868 24.0422 11.9439C24.0422 16.8837 20.7554 21.0642 16.2037 22.5421",
			stroke: "#1F006C",
			strokeMiterlimit: 10,
			strokeLinecap: "round"
		})
	]
});
export default SvgPowerIcon;
